import { render, staticRenderFns } from "./ViewAssessment.vue?vue&type=template&id=6a1af0e3&"
import script from "./ViewAssessment.vue?vue&type=script&lang=js&"
export * from "./ViewAssessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports